import classNames from 'classnames/bind';
import { useContext } from 'react';
import {
  FilterKeys,
  InternationalFilterContext,
} from 'contexts/internationalFilter';
import { TripType } from 'contexts/searchParams';
import useAirportDetailList from 'hooks/useAirportDetailList';
import styles from '../index.module.scss';
import Airport from './airport';

const cx = classNames.bind(styles);

interface IProps {
  tripType: TripType;
}

const titles = ['출발공항', '도착공항'];
const clickCodes = ['ift.apdep', 'ift.aparr'];

export default function AirportFilter({ tripType }: IProps) {
  const {
    filterState: { [FilterKeys.airport]: airportSelected },
    filterStore: { airportFilter },
    setFilterState,
  } = useContext(InternationalFilterContext);
  const airportCodes = Array.from(
    airportFilter.reduce(
      (merged, [departures, arrivals]) =>
        new Set([
          ...Array.from(merged),
          ...Array.from(departures.getValueSet()),
          ...Array.from(arrivals.getValueSet()),
        ]),
      new Set<string>([]),
    ),
  );
  const { data } = useAirportDetailList(airportCodes);

  if (!data || !airportFilter.length) return null;

  const airportNames = new Map(
    data.airportDetailList.map(({ iataCode, airportName }) => [
      iataCode,
      airportName,
    ]),
  );

  function onSelectAiport(index: number, key: number, value: string) {
    if (airportSelected[index][key].has(value)) {
      airportSelected[index][key].delete(value);
    } else {
      airportSelected[index][key].add(value);
    }
    setFilterState(FilterKeys.airport, airportSelected);
  }

  return (
    <>
      {tripType === TripType.MD
        ? airportFilter.map((filters, index) => (
            <div className={cx('subsection')} key={index}>
              <div className={cx('title')}>{index + 1}여정</div>
              <div className={cx('md_filters')}>
                {filters.map(({ items }, key) => (
                  <div className={cx('col')} key={key}>
                    <div className={cx('subtitle')}>{titles[key]}</div>
                    <div className={cx('filters')}>
                      {items.map(({ value }) => (
                        <Airport
                          key={value}
                          checked={airportSelected[index][key].has(value)}
                          clickCode={`${clickCodes[key]}${index + 1}`}
                          label={airportNames.get(value)}
                          value={value}
                          onChange={() => {
                            onSelectAiport(index, key, value);
                          }}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        : airportFilter[0].map(({ items }, key) => (
            <div className={cx('subsection')} key={key}>
              <div className={cx('title')}>{titles[key]}</div>
              <div className={cx('filters')}>
                {items.map(({ value }) => (
                  <Airport
                    key={value}
                    checked={airportSelected[0][key].has(value)}
                    clickCode={clickCodes[key]}
                    label={airportNames.get(value)}
                    value={value}
                    onChange={() => {
                      onSelectAiport(0, key, value);
                      if (tripType === TripType.RT) {
                        onSelectAiport(1, +!key, value);
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
    </>
  );
}
